import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import ApplyModuleTypes from '@/store/modules/middleGround/my/apply/interface';

const applyModule: Module<ApplyModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageActivityApplyReadList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageActivityApplyReadList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateActivityApplyReadStatus(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateActivityApplyReadStatus", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default applyModule;